"use client"
import Script from 'next/script';
import styles from './styles.module.scss';

const NewsletterForm = props => {
    const {portalId, formId, colorScheme} = props || {};
    return(
      <>
        <Script
          src="//js.hsforms.net/forms/embed/v2.js"
          strategy="afterInteractive"
          onLoad={() => {
            if (window.hbspt) {
              window.hbspt.forms.create({
                region: "na1",
                portalId: portalId,
                formId:  formId,
                target: "#newsletterForm"
              });
            }
          }}
        />
        <section className={styles.newsletterForm}>
          <div id="newsletterForm" className={`hsForm ${colorScheme}`}></div>
        </section>
      </>

    );
}

export default NewsletterForm;